module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "detai-top text-l"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.data.title) + "\n\t\t\t"), (_vm.data.specLabel) ? _c('span', [_vm._v("(" + _vm._s(_vm.data.specLabel) + ")")]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v("\n                " + _vm._s(_vm.data.subTitle) + "\n                "), (_vm.data.areaLimit) ? _c('span', [_vm._v("(限售湖北)")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "pirce"
  }, [_c('span', {
    staticClass: "new-price red"
  }, [_vm._v("￥" + _vm._s(_vm._f("fen2yuan")(_vm.data.price)))]), _vm._v(" "), _c('span', {
    staticClass: "old-price"
  }, [_vm._v("￥" + _vm._s(_vm._f("fen2yuan")(_vm.data.didiMarketPrice)))]), _vm._v(" "), (_vm.channel) ? _c('span', {
    staticClass: "red-tag"
  }, [_vm._v("热卖")]) : _vm._e(), _vm._v(" "), (_vm.data.viewCount >= 0) ? _c('span', {
    staticClass: "fr"
  }, [_vm._v("浏览 " + _vm._s(_vm.data.viewCount))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "bright params"
  }, [_c('h1', [_vm._v("产品特点")]), _vm._v(" "), _c('div', _vm._l((_vm.data.detailImages), function(detailImage) {
    return _c('img', {
      key: detailImage,
      attrs: {
        "src": _vm.UPLOAD_DOMAIN + detailImage
      }
    })
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08efd078"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Detail/Content.vue
// module id = 513
// module chunks = 0